import { FORUM_ARCHIVE_CAMPAIGNS_PAGE_TITLE, SEO_TITLE_FORUM_CAMPAIGN } from 'mk/autogenerated/translations/ArchivedCampaignsPage.dbab7dad9521a992a1045e1f3c7746da'
import { toastAdd } from 'mk2/actions';
import ArchivedCampaigns from 'mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaigns';
import { forumArchivedCampaignsLoad } from 'mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaigns.actions';
import archivedCampaignsReducer from 'mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaigns.reducers';
import archivedCampaignsSaga from 'mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaigns.sagas';
import {
    getArchivedCampaignsState,
    getArchivedCampaignsTopics,
} from 'mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaigns.selectors';
import { ArchivedCampaignsEntity } from 'mk2/apps/forum/schemas';
import { forumTopicsUrl } from 'mk2/apps/forum/urls';
import { OwnProps as ServerErrorToastProps } from 'mk2/components/toasts/ServerErrorToast';
import Loadable from 'mk2/helpers/Loadable';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page, { BrandingProps, HalfpageProps } from 'mk2/pages/Page';
import { AppState, getResponseRenderedAt } from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { Store } from 'mk2/store/configureStore';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

const ServerErrorToast = Loadable<ServerErrorToastProps>({
    loader: () => import('mk2/components/toasts/ServerErrorToast' /* webpackChunkName: "ServerErrorToast" */),
    modules: ['mk2/components/toasts/ServerErrorToast'],
    webpack: () => [require.resolveWeak('mk2/components/toasts/ServerErrorToast')],
});

interface OwnProps {
    className?: string;
}
interface StateProps {
    items: ArchivedCampaignsEntity[];
    loadingState: LoadingState;
    errorMessage: string;
    renderedAt: number;
}

interface DispatchProps {
    onLoad();

    onFailureToast();
}

type RouteProps = RouteComponentProps<{}>;
export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class ArchivedCampaignsPage extends Page<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const archivedCampaignsState = getArchivedCampaignsState(state);

            return {
                errorMessage: archivedCampaignsState.errorMessage,
                loadingState: archivedCampaignsState.loadingState,
                items: getArchivedCampaignsTopics(state),
                renderedAt: getResponseRenderedAt(state),
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onLoad: forumArchivedCampaignsLoad,

            onFailureToast: () => toastAdd('error', {
                component: ServerErrorToast,
            }),
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_FORUM_CAMPAIGN;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <ArchivedCampaigns {...props} />
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return true;
    }

    public getDefaultBackPath(props: Props): string {
        return forumTopicsUrl;
    }

    public getHalfpageProps(props: Props): HalfpageProps {
        return {
            zone: 'Forum Category - Halfpage Sticky (Desktop)',
        };
    }

    public getBrandingProps(props: Props): BrandingProps {
        return {
            zone: 'Forum - Branding',
        };
    }

    public getHeaderTitle(props: Props): string {
        return FORUM_ARCHIVE_CAMPAIGNS_PAGE_TITLE;
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer('containers.forum.forumArchivedCampaigns', archivedCampaignsReducer);
        store.injectSaga('containers.forum.forumArchivedCampaigns', archivedCampaignsSaga);
    }

}
